import {AxiosError} from 'axios';
import {DELETE_REQUEST_FILE_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteRequestFile = ({onSuccess, onError}: Input = {}) => {
  const deleteRequestFile = async (fileUuid: string) => {
    await axiosClient.delete<void>(DELETE_REQUEST_FILE_URL(fileUuid));
  };

  return useCustomMutation(deleteRequestFile, {
    onSuccess,
    onError,
  });
};
